import { StyleSheet } from 'react-native'
import type { Theme } from '../src/theme/getTheme'

/** Styles for create page first-paint skeleton (calendar + content area). No inline styles in create index. */
export const getCreateCalendarSkeletonStyles = (_theme: Theme) =>
  StyleSheet.create({
    calendarStrip: {
      width: '100%' as const,
      alignSelf: 'center' as const,
      backgroundColor: 'transparent',
      paddingVertical: 6,
      paddingHorizontal: 10,
      marginBottom: 0,
      marginHorizontal: 16,
    },
    headerRow: {
      flexDirection: 'row' as const,
      alignItems: 'center' as const,
      justifyContent: 'space-between' as const,
      marginBottom: 6,
    },
    datesRow: {
      flexDirection: 'row' as const,
      width: '100%' as const,
      justifyContent: 'space-between' as const,
    },
  })
